"use client";

import { Instagram, Mail, Pin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="flex flex-col gap-3">
        {[0, 1, 2, 3].map(i => <li key={i} data-index={i}>
            <div className="h-5 w-32 bg-muted/30 animate-pulse rounded-md" />
          </li>)}
      </ul>;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="font-default text-[15px] text-foreground/90 inline-block relative pb-0.5 transition-colors duration-300 hover:text-[var(--chart-2)] after:absolute after:left-0 after:bottom-0 after:h-px after:w-0 after:bg-[var(--chart-2)] after:transition-all after:duration-500 hover:after:w-full">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
const membershipLinks = [{
  label: "Line Sheet",
  to: "/CollectionsPage"
}, {
  label: "Fabric Sourcing",
  to: "/AtelierPage"
}, {
  label: "Design Ethics",
  to: "/AtelierPage"
}, {
  label: "Private Showings",
  to: "/InquiriesPage"
}];
const socialLinks = [{
  label: "Instagram",
  href: "#",
  icon: Instagram
}, {
  label: "Pinterest",
  href: "#",
  icon: Pin
}, {
  label: "Newsletter",
  href: "mailto:studio@studiothorne.com",
  icon: Mail
}];
const legalLinks = [{
  label: "Privacy",
  to: "#"
}, {
  label: "Terms",
  to: "#"
}, {
  label: "Cookies",
  to: "#"
}];
export default function StudioThorneFooter() {
  return <section data-section-id="2325" id="studio-thorne-footer" className="dark bg-background text-foreground pt-24 pb-12 px-6 md:px-12 lg:px-20">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          {}
          <div className="md:col-span-4 flex flex-col gap-6">
            <Link to="/" className="inline-block">
              <WvcLogo className="h-12 w-auto" />
            </Link>
            <p className="font-serif italic text-lg text-muted-foreground leading-relaxed max-w-sm">
              Engineering the future of technical couture.
            </p>
            <address className="not-italic font-default text-[11px] tracking-[0.18em] uppercase text-muted-foreground leading-loose">
              12 Atelier Way
              <br />
              Design District, London
              <br />
              ST1 0TH
            </address>
          </div>

          {}
          <div className="md:col-span-3 flex flex-col gap-5">
            <h3 className="font-default text-[11px] tracking-[0.22em] uppercase text-[var(--chart-2)]">
              Navigation
            </h3>
            <MenuProvider menu_id="3">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="md:col-span-3 flex flex-col gap-5">
            <h3 className="font-default text-[11px] tracking-[0.22em] uppercase text-[var(--chart-2)]">
              Atelier
            </h3>
            <ul className="flex flex-col gap-3">
              {membershipLinks.map((link, i) => <li key={link.label} data-index={i}>
                  <Link to={link.to} className="font-default text-[15px] text-foreground/90 inline-block relative pb-0.5 transition-colors duration-300 hover:text-[var(--chart-2)] after:absolute after:left-0 after:bottom-0 after:h-px after:w-0 after:bg-[var(--chart-2)] after:transition-all after:duration-500 hover:after:w-full">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="md:col-span-2 flex flex-col gap-5">
            <h3 className="font-default text-[11px] tracking-[0.22em] uppercase text-[var(--chart-2)]">
              Contact
            </h3>
            <Link to="mailto:studio@studiothorne.com" className="font-default text-[15px] text-foreground/90 inline-block relative pb-0.5 transition-colors duration-300 hover:text-[var(--chart-2)] after:absolute after:left-0 after:bottom-0 after:h-px after:w-0 after:bg-[var(--chart-2)] after:transition-all after:duration-500 hover:after:w-full break-all">
              studio@studiothorne.com
            </Link>
            <ul className="flex flex-col gap-4 mt-2">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <li key={social.label} data-index={i}>
                    <Link to={social.href} newTab aria-label={social.label} className="inline-flex items-center justify-center text-[var(--chart-2)]/70 transition-all duration-300 hover:text-[var(--chart-2)] hover:scale-110">
                      <Icon className="h-6 w-6" strokeWidth={1.25} />
                    </Link>
                  </li>;
            })}
            </ul>
          </div>
        </div>

        {}
        <Separator className="my-12 bg-[var(--chart-2)]/30" />

        {}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <p className="font-default text-[10px] tracking-[0.22em] uppercase text-muted-foreground">© Studio Thorne, MMXXVI — All Rights Reserved</p>

          {}
          <div className="hidden md:flex items-center justify-center text-[var(--chart-2)]/60">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" className="h-4 w-4" aria-hidden="true">
              <path d="M12 2c-2 3-5 4-5 8 0 2 1 3 2 4-2 1-3 3-3 5 3 0 5-1 6-3 1 2 3 3 6 3 0-2-1-4-3-5 1-1 2-2 2-4 0-4-3-5-5-8z" />
              <path d="M12 14v8" />
            </svg>
          </div>

          <ul className="flex items-center gap-3 flex-wrap">
            {legalLinks.map((link, i) => <li key={link.label} data-index={i} className="flex items-center gap-3">
                <Link to={link.to} className="font-default text-[10px] tracking-[0.22em] uppercase text-muted-foreground transition-colors duration-300 hover:text-[var(--chart-2)]">
                  {link.label}
                </Link>
                {i < legalLinks.length - 1 && <span className="text-[var(--chart-2)] text-xs leading-none">
                    •
                  </span>}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}